<template>
  <div v-if="visible" class="tw_process_group_list" :class="{open: open}">
    <div class="inner" @click="toggle">
      <img class="arrow" src="@/assets/images/icons/accordion_arrow.svg">
      <div class="group_name">{{group.name}}</div>
    </div>
    <transition
      name="content"
      @enter="enter"
      @after-enter="afterEnter"
      @leave="leave"
      @after-leave="afterLeave"
    >
      <div v-show="open" class="collapse">
        <template>
          <div class="twoColumn" style="margin-top:0">
            <template v-for="item in group.children">
              <tw-process-group-list-item
                :key="item.key"
                :item="item"
                :tableName="tableName"
                :groupName="group.variableName"
                :serialIndexes="{}"
                :serialItems="{}"
                :isEditMode="isEditMode"
                :poolName="poolName"
                :poolIndex="selectIndex"
              />
            </template>
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import TwProcessGroupListItem from '@/components/molecules/TwProcessGroupListItem';
import { collapseTransition } from '@/utils/nextFrame';

export default {
  name: 'TwProcessGroupListPreviewIpDnItem',
  inject: ['s'],
  props: {
    group: Object,
    tableName: String,
    isEditMode: Boolean,
    poolName: String,
    selectIndex: Number,
    initOpen: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TwProcessGroupListItem,
  },
  mixins: [collapseTransition],
  data() {
    return {
      open: this.initOpen,
    };
  },
  computed: {
    visible() {
      return this.group.variableName !== 'policyGrp';
    },
  },
  created() {
    this.$parent.$on('openAll', this.openAll);
    this.$parent.$on('closeAll', this.closeAll);
  },
  beforeDestroy() {
    this.$parent.$off('openAll', this.openAll);
    this.$parent.$off('closeAll', this.closeAll);
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    openAll() {
      this.open = true;
    },
    closeAll() {
      this.open = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .tw_process_group_list {
    margin-bottom: 16px;
    .inner {
      display: flex;
      align-items: center;
      padding: 10px 18px 10px 0;
      width: 100%;
      height: auto;
      cursor: pointer;

      img {
        display: block;
        width: 12px;
        height: 12px;
        transition: transform .3s;
      }

      .group_name {
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        color: #000000;
        margin-left: 8px;
      }

      .tw_button {
        width: 190px;
        padding-right: 0;
        padding-left: 0;
        margin-left: auto;
      }
    }

    .collapse {
      border-top: 1px solid #EDEDF4;
      padding: 12px 0 10px;
      width: 100%;
    }

    &.open {
      .inner img.arrow {
        transform: rotate(90deg);
      }
    }
  }

  .content-enter-active,
  .content-leave-active {
    transition: height .3s;
  }

  .twoColumn {
    display: flex;
    flex-wrap: wrap;
    margin-top: 32px;
    padding-left: 16px;

    .edit_document_payment_terms_hr {
      display: block;
      width: 100%;
      height: 1px;
      background: $color_gray_300;
      margin: 0 0 24px;
      border: 0;
    }

    .document_payment_terms_hr {
      display: block;
      width: 100%;
      height: 1px;
      background: $color_gray_300;
      margin: 0 0 12px;
      border: 0;
    }
  }
</style>
